import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUpWhite = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 9,
	viewBox: "0 0 16 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M7.21967 0.21967C7.51256 -0.0732233 7.98744 -0.0732233 8.28033 0.21967L15.2803 7.21967C15.5732 7.51256 15.5732 7.98744 15.2803 8.28033C14.9874 8.57322 14.5126 8.57322 14.2197 8.28033L7.75 1.81066L1.28033 8.28033C0.987437 8.57322 0.512563 8.57322 0.21967 8.28033C-0.0732233 7.98744 -0.0732233 7.51256 0.21967 7.21967L7.21967 0.21967Z",
		fill: "white"
	})
});
export default SvgChevronUpWhite;
